import HotelStay from "../components/Venue/HotelsStay";

export default function Hotel() {
    return(
        <main className=" mt-28">
            <HotelStay />
        </main>
    )
}